<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between" style="zoom: 0.85">
      <div>
        <div class="section-title">{{ $t("transferStockRequestsLogs") }}</div>
      </div>
      <div class="d-flex align-items-center">
        <div v-if="request_logs && request_logs.length > 0" class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
    <br />

    <div class="white-wrapper">
      <div class="row" style="zoom: 0.9">
        <div class="col-md-3 mb-1">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema ? 'shift-up' : ''">
              {{ $tc("cinema", 1) }}</label
            >
            <multiselect
              :options="cinemas"
              v-model="selectedCinema"
              :searchable="true"
              placeholder=""
              label="cine_name"
              track-by="cine_id"
              @select="onSelectCinema($event, 'select')"
              @remove="onSelectCinema($event, 'remove')"
              :allowEmpty="false"
            >
            </multiselect>
          </div>
        </div>
        <!-- from date -->
        <div class="col-lg-2 col-xl-2 align-self-center md-sm-3 mb-1">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="from_date"
                v-on:click="onDateChange({ event: null, name: 'fromDate' })"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                @selected="onDateChange({ event: $event, name: 'fromDate' })"
                ref="programaticOpen"
                :value="from_date"
                v-validate="'required'"
              ></Datepicker>
              <label :class="from_date ? 'active' : ''">{{
                $t("fromdate")
              }}</label>
            </div>
          </div>
        </div>
        <!-- to date -->
        <div class="col-lg-2 col-xl-2 align-self-center mb-1">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="to_date"
                v-on:click="onDateChange({ event: null, name: 'toDate' })"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                @selected="onDateChange({ event: $event, name: 'toDate' })"
                ref="programaticOpen"
                :value="to_date"
                v-validate="'required'"
              ></Datepicker>
              <label :class="to_date ? 'active' : ''">{{
                $t("To Date")
              }}</label>
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-between align-items-center col-2 col-md-2 col-lg-2 mb-1"
        >
          <multiselect
            v-model="selectedTypeFilter"
            :placeholder="'Filter'"
            :options="fillterArray"
            label="name"
            track-by="id"
            :multiple="false"
            @select="onSelectFilterType($event, 'SELECT')"
            @remove="onSelectFilterType($event, 'REMOVE')"
          ></multiselect>
        </div>
        <div class="col-md-2 col-xl-2">
          <button @click.prevent.stop="onFetch()" class="btn btn-primary px-5">
            {{ $t("fetch") }}
          </button>
        </div>
      </div>
      <!-- LIST VIEW DESIGNATION -->
      <div class="swc-report mt-3">
        <table class="swc-report-table" v-if="listView">
          <thead>
            <tr class="lightBluebg">
              <th></th>
              <!-- <th>Cinema</th> -->
              <th>Date</th>
              <th>Request ID</th>
              <th>Requested By</th>
              <th>From Store</th>
              <th>To Store</th>
              <th>Status</th>
              <th>Remarks</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="request_logs && request_logs.length > 0">
            <template v-for="(request, requestKey) in request_logs_grouped">
              <tr :key="requestKey">
                <td class="text-left p-0">
                  <!-- <span
                    @click="showHideDetails(request)"
                    class="icon-eye mr-1"
                  ></span> -->
                  <div
                    class="btn"
                    @click="showHideDetails(request)"
                    style="cursor: pointer"
                    tabindex="0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#4682B4"
                      class="bi bi-view-list"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2zm0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14z"
                      />
                    </svg>
                  </div>
                </td>
                <!-- <td class="text-left">
                  {{ request.cinema_name }}
                </td> -->
                <td class="text-left">
                  {{ request.date | fulldaydateparse }}
                </td>
                <td class="text-left">
                  {{ request.request_code }}
                </td>
                <td class="text-left">
                  {{ request.requested_by }}
                </td>
                <td class="text-left">
                  {{ request.from_store }}
                </td>
                <td class="text-left">
                  {{ request.to_store }}
                </td>
                <td class="text-left">
                  {{ request.status }}
                </td>
                <td class="text-left" :title="request.remarks">
                  <div class="remarkColummn">{{ request.remarks }}</div>
                </td>
                <td class="text-left">
                  <template
                    v-if="
                      request.status == 'Pending' &&
                      $can('update', 'Stock Transfer Requests')
                    "
                    ><div style="zoom: 0.85">
                      <button
                        class="btn btn-sm btn-primary px-2"
                        @click="onRequestConfirmation(request, 'approve')"
                      >
                        Approve
                      </button>
                      <button
                        class="btn btn-sm btn-outline-primary px-3"
                        @click="
                          goToRoute(
                            '/fnb/update-stocks-tranfer-requests',
                            request
                          )
                        "
                      >
                        Edit
                      </button>
                      <button
                        class="btn btn-sm btn-danger px-2"
                        @click="onRequestConfirmation(request, 'reject')"
                      >
                        Reject
                      </button>
                    </div>
                  </template>
                  <template v-else>
                    {{
                      !["Pending"].includes(request.status)
                        ? `${request.status} By ${request.updated_user}`
                        : "-"
                    }}
                  </template>
                </td>
              </tr>
              <tr
                :style="request.more ? '' : 'display: none'"
                :key="requestKey"
              >
                <td colspan="100%" style="background: #efefef; padding: 15px">
                  <b-collapse
                    v-model="request.more"
                    class="swc-report"
                    style="zoom: 0.95; background: white"
                  >
                    <table
                      class="swc-report-table text-center"
                      style="width: 100%"
                    >
                      <tr>
                        <th>Raw Material</th>
                        <th v-if="['Pending'].includes(request.status)">
                          Qty. Avl ( {{ request.from_store }})
                        </th>
                        <th>Qty. Requested</th>
                        <th>Qty. Transfered</th>
                        <th>Unit</th>
                        <th>Net Price</th>
                        <th>Total Tax</th>
                        <th>Gross Price</th>
                      </tr>

                      <tbody
                        v-if="request.itemsList && request.itemsList.length > 0"
                      >
                        <tr
                          v-for="(item, itemindex) in request.itemsList"
                          :key="itemindex"
                        >
                          <td class="text-left">{{ item.rm_name }}</td>
                          <td
                            class="text-right"
                            v-if="['Pending'].includes(request.status)"
                          >
                            {{ currFormat(item.current_store_quantity) || 0 }}
                          </td>
                          <td class="text-right">
                            {{
                              currFormat(item.transfer_quantity_requested) || 0
                            }}
                          </td>
                          <td class="text-right">
                            <span
                              v-if="
                                ['Approved', 'AWC'].includes(request.status)
                              "
                            >
                              {{
                                currFormat(item.transfer_quantity) || 0
                              }}</span
                            >
                            <span v-else>{{ request.status }}</span>
                          </td>
                          <td class="text-left">{{ item.uom_name || "-" }}</td>
                          <td class="text-right">
                            {{ currFormat(item.poi_price) }}
                          </td>
                          <td class="text-right">
                            {{ currFormat(item.poi_tax_amount) }}
                          </td>
                          <td class="text-right">
                            {{ currFormat(item.poi_total_amount) }}
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="7">
                            <NoRecords />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-collapse>
                </td>
              </tr>
            </template>
            <tr class="w-100" v-if="request_logs.length == 0">
              <td colspan="10">
                <h6 class="mb-0">
                  No Records Found
                  <br />
                </h6>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="10">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>

        <div class="info-section">
          <div style="text-align: right; margin-top: 10px; font-size: 12px">
            *AWC - Approved With Cancellation
          </div>
        </div>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <b-modal
      id="reject_confirmation"
      title="Reject Stock transfer?"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          {{ `Are you sure you want to reject stock transfer` }}
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('reject_confirmation')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="updateRequest('reject')"
        >
          Confirm
        </button>
      </div>
    </b-modal>

    <b-modal
      id="approve_confirmation"
      title="Approved Stock transfer?"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          {{ `Are you sure you want to transfer the stock?` }}
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('approve_confirmation')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-info btn-info-lg px-4 fs-14"
          @click.prevent.stop="updateRequest('accept')"
        >
          Confirm
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      selectedType: null,
      selectedRequest: null,
      transferStockexcel: "",
      isRoleID: true,
      getitem: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedid: "",
      viewingnumbers: [],
      gridView: false,
      listView: true,
      request_logs: [],
      request_logs_grouped: [],
      cinema_id: "",
      selectedCinema: "",
      cinema_address: "",
      searchCinema: "",
      cinemas: [],
      from_date: null,
      to_date: null,
      selectedTypeFilter: {
        id: 1,
        name: "Pending",
        status: "Pending",
      },
      fillterArray: [
        {
          id: 1,
          name: "Pending",
          status: "Pending",
        },
        {
          id: 2,
          name: "Rejected",
          status: "Rejected",
        },
        {
          id: 3,
          name: "Approved",
          status: "Approved",
        },
        {
          id: 5,
          name: "AWC",
          status: "AWC",
        },
        {
          id: 4,
          name: "All",
          status: "All",
        },
      ],
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }

    if (!isNaN(String(obj))) {
      this.getCinemas(obj);
    } else {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.getCinemas(CinemaObj.cine_id);
      }
    }
    this.getviewingnumber();
  },
  mounted() {},
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    goToRoute: function (path, { request_id, cinema_id }) {
      this.$router.push({
        path: path,
        query: {
          request_id: request_id,
          cinema_id: cinema_id,
        },
      });
    },
    onSelectFilterType(event, type) {
      this.onFetch();
    },
    onRequestConfirmation(request, type = "approve") {
      this.selectedRequest = request;
      if (type == "reject") {
        this.$bvModal.show("reject_confirmation");
      } else if (type == "approve") {
        this.$bvModal.show("approve_confirmation");
      }
    },
    updateRequest(action = "accept") {
      let request = this.selectedRequest;
      if (action == "accept") {
        let loader = this.$loading.show();
        let payload = {
          request_id: request["request_id"],
          cinema_id: request["cinema_id"],
          status: "Approved",
        };
        PosFnbService.UpdateTransferStockRequest(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message || "Approved");
              this.getTransferRequests();
            } else {
              this.$toasted.show(data.message || "Failed");
            }
          })
          .finally(() => {
            loader.hide();
            this.$bvModal.hide("approve_confirmation");
          });
      } else if (action == "reject") {
        let loader = this.$loading.show();
        let payload = {
          request_id: request["request_id"],
          cinema_id: request["cinema_id"],
          status: "Rejected",
        };
        PosFnbService.UpdateTransferStockRequest(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message || "Rejected");
              this.getTransferRequests();
            } else {
              this.$toasted.show(data.message || "Failed");
            }
          })
          .finally(() => {
            loader.hide();
            this.$bvModal.hide("reject_confirmation");
          });
      } else {
        this.$toasted.show("Invalid Request");
      }
    },
    showHideDetails: function (request) {
      if (request.hasOwnProperty("more")) {
        request.more = !request.more;
      } else request.more = true;

      this.request_logs_grouped.forEach((p) => {
        if (request.request_id != p.request_id) {
          p.more = false;
        }
      });

      this.$forceUpdate();
    },
    onFetch: function () {
      if (this.selectedCinema) {
        this.getTransferRequests();
      } else {
        this.$toasted.show("select cinema");
      }
    },
    donwloadExcel: function () {
      this.getTransferRequests("Y");
    },
    onDateChange(payload) {
      console.log("payload", payload);
      if (payload.name == "fromDate") {
        this.from_date = payload.event;
      }
      if (payload.name == "toDate") {
        this.to_date = payload.event;
      }
    },

    cancelStockTransfer() {
      this.transfer_to_reject = "";
      this.$bvModal.hide("confirmation");
    },
    rejectStockTransfer() {
      if (!this.transfer_to_reject.tsl_id) {
        this.$toasted.show("No transfer log id found");
        return;
      }
      let loader = this.$loading.show();
      MasterService.RejectToCinemaStockTransfer(this.transfer_to_reject.tsl_id)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.request_logs.forEach((t) => {
              if (t.tsl_id == this.transfer_to_reject.tsl_id)
                t.transfer_status = "Reject";
            });
            this.$forceUpdate();
          }
          this.$toasted.show(data.message);
        })
        .catch(this._CatchError)
        .finally(() => {
          this.$bvModal.hide("confirmation");
          loader.hide();
        });
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getTransferRequests();
      } else {
        this.currentPage = event;
        this.getTransferRequests();
      }
    },
    getCinemas: function (cine_id) {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            this.cinemas = data.Records;
            this.cinemasCopy = data.Records;
            this.cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {});
    },
    onSelectCinema: function (cinema, type = "select") {
      if (type == "remove") {
        this.selectedCinema = "";
        this.cinema_address = "";
        this.cinema_id = null;
      } else {
        this.selectedCinema = cinema;
        this.cinema_address = cinema.cine_address;
        this.cinema_id = cinema.cine_id;
        this.onFetch();
      }
    },
    getTransferRequests: function (isExcel = "N") {
      if (!this.cinema_id) {
        return this.$toasted.show("Please select Cinema");
      } else {
        let loader = this.$loading.show();
        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          cinema_id: this.cinema_id,
          cinema_name: this.selectedCinema["cine_name"],
          fromDate: this.from_date,
          toDate: this.to_date,
          status: this.selectedTypeFilter["status"] || "Pending",
        };

        PosFnbService.TransferStockRequestLogs(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records && data.Records.length > 0) {
              this.request_logs = data.Records;
              this.request_logs_grouped = data.groupedData;
              // this.transferStockexcel = data.excelPath;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue = this.perPage;
              } else if (data.totalRows) {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
              if (data.excelPath && isExcel == "Y") {
                window.open(data.excelPath, "_blank");
              }
            } else {
              this.request_logs = [];
              this.$toasted.show(data.message);
              this.rows = 0;
              this.selectedvalue = "0";
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>

<style scoped>
.swc-report-table th,
.swc-report-table td {
  border: 1px solid #c7c6c6;
}

.showBorder-down {
  border: 1.5px solid black;
  border-top: 0;
}

.remarkColummn {
  width: 110px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.hyperlink_reject {
  color: rgb(236, 36, 36);
}
.hyperlink_edit {
  color: rgb(109, 175, 192);
}
.hyperlink_approve {
  color: rgb(52, 111, 219);
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/TransferStocks/transferRequestLogs.vue